import { NewInstanceScreen } from 'feature/editorial-dash/question-topic-manager';
import { CLICK, componentWithVariants, demoFile, extend, story, variant } from 'system/demo';

import { ChannelSelectionFeature, NewInstanceChannelWidget } from '../display-channel-selection';

demoFile('open-modules/zdf/feature/editorial-dash/display-channel-selection');

const channelState = {
    modulePublic: {
        channel: {
            all: {
                channel1: { key: 'channel1', name: 'Channel 1', from: 'a', isDefault: true },
            },
            instanceToChannel: {},
        },
    },
    serverCall: {
        channel: {
            getUserChannels: async () => ['channel1'],
            assignContentToChannel: async () => Promise.resolve(),
            reassignContentToChannel: async () => Promise.resolve(),
        },
        questions: {
            add: async () => ({ questionKey: 'q1' }),
        },
    },
    sessionData: { personaKey: 'a' },
    roles: ['Moderator'],
};

const baseConfig = {
    instanceTopLeftWidgets: [],
    instanceTopRightWidgets: [],
    instanceBodyWidgets: [],
    instanceBottomLeftWidgets: [],
    instanceBottomRightWidgets: [],
    instanceFilters: [],
    newInstanceWidgets: [],
    newInstanceCreateBlockers: [],
    newInstanceCreators: [],
    newInstancePostCreateTriggers: [],
};

componentWithVariants(
    'NewInstanceChannelWidget',
    NewInstanceChannelWidget,
    {
        args: { structureKey: 'question', instance: {}, setInstance: () => {} },
    },
    [
        variant('Allowed structure', { args: { structureKey: 'question', instance: {}, setInstance: () => {} }, state: channelState }),
        variant('Disallowed structure', { args: { structureKey: 'foo', instance: {}, setInstance: () => {} }, state: channelState }),
    ],
);

extend(
    'NewInstanceScreen',
    'Channel Selection',
    NewInstanceScreen,
    {
        args: { structureKey: 'question' },
        features: ['question-topic-manager', 'editorialdashchannelselection'],
        state: channelState,
        config: { ...baseConfig, ...ChannelSelectionFeature.providesConfig },
        structureKey: 'editorialdash',
    },
    [story('Assign Channel', [CLICK('Create question')])],
);
